import styled, { css } from "styled-components";

import { mediumScreenAndAbove } from "../lib/mediaQuery";
import { Icon } from "./Icon";
import { Callout, Caption2 } from "./Typography";

export const FantasyBadge = ({ className }: { className?: string }) => (
  <Badge className={className}>
    <Icon
      name="Checkmark"
      color="var(--focus-link-color)"
      width={14}
      height={14}
      css={`
        display: none;
        margin: 0 var(--spacing-xxs);
        ${mediumScreenAndAbove(css`
          display: block;
        `)}
      `}
    />
    <Icon
      name="Checkmark"
      color="var(--focus-link-color)"
      width={10}
      height={10}
      css={`
        display: block;
        margin: 0 var(--spacing-xxs);
        ${mediumScreenAndAbove(css`
          display: none;
        `)}
      `}
    />
    <Callout
      css={`
        display: none;
        color: var(--focus-link-color);
        white-space: nowrap;
        ${mediumScreenAndAbove(css`
          display: block;
        `)}
      `}
    >
      Fantasy Vault
    </Callout>
    <Caption2
      css={`
        display: block;
        color: var(--focus-link-color);
        white-space: nowrap;
        ${mediumScreenAndAbove(css`
          display: none;
        `)}
      `}
    >
      Fantasy Vault
    </Caption2>
  </Badge>
);

const Badge = styled.div`
  display: flex;
  padding: 2px 10px 2px 4px;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  border: 1px solid var(--focus-link-color);
  background: rgba(0, 0, 0, 0.75);
  width: fit-content;
`;
